const hideUnit = (units, contract) => {
  const { state_machine: state } = contract
  const hasContract = state && state !== 'draft' && state !== 'canceled'
  return !!Number(units.hide_unit_number) && !hasContract
}

export default hideUnit
